<template>
  <div class="role-page full-height">
      <table-con>
        <div slot="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
             <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>物流公司配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div slot="search">
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title" style="width:110px">物流公司名称:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.companyName"
                size = "small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row" >
            <div class="query-title" style="text-align:right">状态:</div>
            <div class="flex1" >
              <el-select v-model="queryInfo.useStatus" placeholder="请选择" size="small" clearable>
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="13" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right" >
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="insert">新增</el-button>
            </div>
          </el-col>
        </el-row>
        </div>
        <div slot="table" class="full-height display-col">
           <el-table
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="recordList"
            border
            height="550"
           >
           <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
           <el-table-column prop="companyName" label="物流公司名称"></el-table-column>
           <el-table-column
               prop="line"
               align="center"
               label="线路">
             <template v-slot="scope">
               {{lineShow(scope.row.line)}}
             </template>
           </el-table-column>
            <el-table-column
              prop="statusQueryWebsit"
              label="状态查询网站">
              <template v-slot="scope">
              <el-popover
                placement="bottom-start"
                width="200"
                trigger="hover"
                :open-delay="500"
                :content="scope.row.statusQueryWebsit">
                <span slot="reference" class="overflowDot">{{scope.row.statusQueryWebsit}}</span>
              </el-popover>
              </template>
            </el-table-column>
             <el-table-column
             prop="customerServiceTel"
             align="center"
              label="客服电话">
            </el-table-column>
             <el-table-column
              prop="notes"
              label="备注">
            </el-table-column>
             <el-table-column
              prop="companySort"
              align="center"
              label="排序">
            </el-table-column>
             <el-table-column
              prop="useStatus"
              :index="indexMethod"  sortable
              align="center"
              label="启用状态">
              <template v-slot="scope">
              {{statusShow(scope.row.useStatus)}}
            </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                class="list-btn btn-blue"
                @click="update(scope.row)">
                编辑
                </el-button>
              </div>
            </template>
          </el-table-column>
          </el-table>
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        </div>
      </table-con>
       <!-- 修改 -->
        <el-dialog
      :title="dialogTitle"
      :visible.sync="updateDialogVisible"
      width="30%"
      @close="updateDialogClose"
    >
        <el-form :model="companyInfo" :rules="rules" ref="companyInfo" label-width="110px" class="demo-companyInfo">
            <el-form-item label="物流公司名称" prop="companyName" >
            <el-input v-model="companyInfo.companyName"></el-input>
            </el-form-item>
            <el-form-item label="线路" prop="line">
              <el-select v-model="companyInfo.line" placeholder="请选择线路">
                <el-option v-for="(item,index) in lineOptions"
                           :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客服电话" prop="customerServiceTel">
            <el-input v-model="companyInfo.customerServiceTel"></el-input>
            </el-form-item>
             <el-form-item label="物流查询网址" prop="statusQueryWebsit">
            <el-input v-model="companyInfo.statusQueryWebsit"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="companySort">
            <el-input v-model="companyInfo.companySort"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="notes">
            <el-input v-model="companyInfo.notes"></el-input>
            </el-form-item>
            <el-form-item label="启用状态" prop="useStatus">
            <el-switch
                 v-model="companyInfo.useStatus"
                 active-text="启用"
                 active-value="0"
                 inactive-text=""
                 inactive-color="#909399"
                 inactive-value="1">
            </el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="form-btn btn-gray" @click="clearForm">取 消</el-button>
          <el-button class="form-btn btn-blue" @click="updateSave('companyInfo')">提 交</el-button>

        </div>
        </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'
export default {
  components: { tableCon },
  data() {
    return {
      companyInfo: {
          id:'',
          companyName:'',
          line:'',
          customerServiceTel:'',
          statusQueryWebsit:'',
          companySort:'',
          notes:'',
          useStatus:''
        },
      queryInfo:{
        companyName:'',
        useStatus:'',
        pageSize:10,
        pageNum:1
      },
      recordList:[],
      total:0,
      dialogTitle:'',
      statusOptions:[
        {
          value: '0',
          label: '启用'
        }, {
          value: '1',
          label: '禁用'
        }
      ],
      lineOptions:[
        {
          value: '空运',
          label: '空运（エア便）'
        }, {
          value: '海运',
          label: '船运（船便）'
        }
      ],
      rules:{
      companyName:[
          {required:true,message:'请输入物流公司名称',trigger:'blur'}
      ],
      line:[
        {required:true,message:'请选择线路',trigger:'blur'}
      ],
      customerServiceTel:[
          {required:true,message:'请输入客服电话',trigger:'blur'}
      ],
      statusQueryWebsit:[
          {required:true,message:'请输入物流查询网址',trigger:'blur'}
      ],
      companySort:[
          {required:true,message:'请输入排序数字',trigger:'blur'}
      ],
      useStatus:[
          {required:true,message:'请选择启用状态',trigger:'blur'}
      ]
          },

      updateDialogVisible:false,
    }
  },
  methods:{
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    updateSave(formName){    //保存按钮
        var my = this;
      //保存按钮
      this.$refs.companyInfo.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          var url = "cms/logisticsCompany/insertAndEdit";
          const { data: res } = await my.$http.post(url, my.companyInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getrecordList();
            my.updateDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    clearForm() {   //弹窗的取消按钮
      this.initForm();
      this.updateDialogVisible=false;
      },
    initForm(){   //初始化弹窗的内容
      this.companyInfo = {
          id:'',
          companyName:'',
          customerServiceTel:'',
          statusQueryWebsit:'',
          companySort:'',
          notes:'',
          useStatus:''
      };
    },
    searchList(){    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList(){
      const {data:res} = await this.$http.get('cms/logisticsCompany/list',{params:this.queryInfo});
      console.log(res);
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear(){    //清空
      this.queryInfo = {
        companyName:'',
        useStatus:'',
        pageSize:10,
        pageNum:1
      }
    },
    statusShow(status){
      switch(status){
        case '1':
        return '禁用'
        break;
        case '0':
        return '启用'
        break;
      }
    },
    update(row){     //编辑
      this.dialogTitle='编辑';
      this.updateDialogVisible = true;
      this.getrecordList;
      this.companyInfo = {
        id:row.id,
        companyName:row.companyName,
        line: row.line,
        customerServiceTel:row.customerServiceTel,
        statusQueryWebsit:row.statusQueryWebsit,
        companySort:row.companySort,
        notes:row.notes,
        useStatus:row.useStatus
      };
    },
    insert(row){     //新增
     this.dialogTitle='新增';
     this.updateDialogVisible = true;
     this.getrecordList;
     this.companyInfo = {
          id:'',
          companyName:'',
          line:'',
          customerServiceTel:'',
          statusQueryWebsit:'',
          companySort:'',
          notes:'',
          useStatus:'0'
      };
    },
    updateDialogClose(){    //关闭弹窗
      console.log('close');
      this.updateDialogVisible = false;
    },
    lineShow(line){
      for (let item of this.lineOptions) {
        if (item.value == line) {
          return item.label
        }
      }
    },
  },
  created() {
    this.getrecordList();
  }
};
</script>

<style lang="less" scoped>
  .role-page > .search-container{
    height: 60px !important;
  }
  .el-table .el-button--small{
    padding: 4px 10px;
  }
</style>
